// Classes
import { EngagementReducerState } from 'Containers/Filter/Engagement/classes/engagement.classes';
import { AttributeObject } from '../classes/attributes.classes';

/**
 * @function getEngagementAttributes
 *
 * Post-processes the attributes for this section of the filter,
 * so that they can just be stringified on the fly and sent to
 * the back end for safe keeping.  This pre-processing allows
 * us to rebuild the Pill attributes effectively and quickly.
 * Meant to be passed into a greater array consisting of all
 * attributes before being sent to the back-end API like so.
 *
 * [visitorTypeAttributes, geographyAttributes...]
 *
 * @param {EngagementReducerState} engagement - The current state
 * of the Engagement filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getEngagementAttributes(engagement)
 */
const getEngagementAttributes = (engagement: EngagementReducerState) => {
  const attributeArray: any[] = [];

  switch (engagement.dateRegistered.selection) {
    case 'Select Recency':
      attributeArray.push(
        `Date Registered with My Institution = ${engagement.dateRegistered.value.label}`
      );
      break;
    case 'Specific Date Range':
      attributeArray.push(
        `Date Registered with My Institution = ${engagement.dateRegistered.value.lower} - ${engagement.dateRegistered.value.upper}`
      );
      break;
    default:
      break;
  }

  const relativeEngagementArray = [
    (engagement.relativeEngagement.high && 'High') || undefined,
    (engagement.relativeEngagement.medium && 'Medium') || undefined,
    (engagement.relativeEngagement.low && 'Low') || undefined,
  ].filter((attributeObject) => typeof attributeObject !== 'undefined');

  if (relativeEngagementArray.length > 0) {
    attributeArray.push(
      `Relative Engagement = ${relativeEngagementArray.join(' or ')}`
    );
  }

  switch (engagement.totalTimeSpent.selection) {
    case 'VT':
      attributeArray.push(
        `Total Time Spent in My VT = ${engagement.totalTimeSpent.value.vt.lower} - ${engagement.totalTimeSpent.value.vt.upper}`
      );
      break;
    case 'IWC':
      attributeArray.push(
        `Total Time Spent in IWC = ${engagement.totalTimeSpent.value.vt.lower} - ${engagement.totalTimeSpent.value.vt.upper}`
      );
      break;
    case 'VT or IWC':
    case 'VT and IWC':
      attributeArray.push(
        `Total Time Spent in My ${engagement.totalTimeSpent.selection} = ${engagement.totalTimeSpent.value.vt.lower} - ${engagement.totalTimeSpent.value.vt.upper} / ${engagement.totalTimeSpent.value.iwc.lower} - ${engagement.totalTimeSpent.value.iwc.upper}`
      );
      break;
    default:
      break;
  }

  if (engagement.scheduledVisit !== 'Any') {
    attributeArray.push(
      `Scheduled Visit with My Institution = ${engagement.scheduledVisit}`
    );
  }

  if (engagement.applied !== 'Any') {
    attributeArray.push(`Apply Now CTA Clicked = ${engagement.applied}`);
  }

  if (engagement.activityWithInstitution.selection !== 'Any') {
    attributeArray.push(
      `Activity with My Institution = ${engagement.activityWithInstitution.selection} ${engagement.activityWithInstitution.value.label}`
    );
  }

  if (engagement.activityWithEAB.selection !== 'Any') {
    attributeArray.push(
      `Activity with EAB Network = ${engagement.activityWithEAB.selection} ${engagement.activityWithEAB.value.label}`
    );
  }

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      `Engagement=${attributeArray.length}`,
      'engagement',
      attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
export default getEngagementAttributes;
try {
    // @ts-ignore
    getEngagementAttributes.displayName = "getEngagementAttributes";
    // @ts-ignore
    getEngagementAttributes.__docgenInfo = { "description": "", "displayName": "getEngagementAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getEngagementAttributes.ts#getEngagementAttributes"] = { docgenInfo: getEngagementAttributes.__docgenInfo, name: "getEngagementAttributes", path: "src/shared/containers/Attributes/utilities/getEngagementAttributes.ts#getEngagementAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }